import { render } from "./BootstrapApp.vue?vue&type=template&id=b8000676&scoped=true"
import script from "./BootstrapApp.vue?vue&type=script&lang=js"
export * from "./BootstrapApp.vue?vue&type=script&lang=js"

import "./BootstrapApp.vue?vue&type=style&index=0&id=b8000676&lang=scss"
import "./BootstrapApp.vue?vue&type=style&index=1&id=b8000676&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8000676"]])

export default __exports__